<div class="field">
    <span class="field-title">Toneladas<span class="asterisk">*</span></span>

    <number-input [initialPlaceHolder]="'Ingresar unas toneladas'" [isIncomplete]="isIncomplete"
    (valueOut)="setElement($event,0)" (keydown)="listenerTab($event)" [max]="getMaxOfTons()" [value]="elementSelected"></number-input>

    <span class="text-is-incomplete" *ngIf="isIncomplete">Completar la siguiente información para continuar.</span>
    <span class="text-is-incomplete" *ngIf="elementSelected>9000">Las toneladas no pueden exceder una cantidad de 9.000.</span>
</div>